import React from 'react';

import { Device, UnmountedHub } from 'api/InteractiveMap/types';

import './SelectedDevice.scss';

interface Props {
  device: Device | UnmountedHub;
  key: number;
  isSelected?: boolean;
  onSelect?: (deviceSlug: string) => void;
}

const SelectedDevice: React.FC<Props> = ({ device, key, isSelected, onSelect }) => {
  const getDeviceName = () => {
    if (device.model.toLowerCase().startsWith('mct')) {
      return `Multi-Catch Mouse Trap \u2116${device.number}`;
    }
    if (device.model.toLowerCase().startsWith('srbm')) {
      return `Smart Rodent Bait Module \u2116${device.number}`;
    }
    if (device.model.toLowerCase().startsWith('hub')) {
      return `Hub \u2116${device.number}`;
    }
    return device.model;
  };

  return (
    <div
      key={key}
      className={`selected-device-row p-3 my-1 d-flex justify-content-between align-items-center rounded-4 ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect && onSelect(device.slug)}
    >
      <div className="d-flex flex-column">
        <h5 className="mb-0">{getDeviceName()}</h5>
        <p className="text-muted">{device.model}</p>
      </div>
      <div className="d-flex">
        <p className="text-muted">{device.serial_number}</p>
      </div>
    </div>
  );
};

export default SelectedDevice;
